'use es6';

export const BAD_URL = 'BAD_URL';
export const BAD_URL_FOR_SOCIAL_SITE = 'BAD_URL_FOR_SOCIAL_SITE';
export const BLOG_INVALID_PARAMETERS = 'BLOG_INVALID_PARAMETERS';
export const BLOG_NOT_FOUND_BY_ID = 'BLOG_NOT_FOUND_BY_ID';
export const BLOG_OBJECT_NOT_FOUND = 'BLOG_OBJECT_NOT_FOUND';
export const CONTENT_NOT_FOUND = 'CONTENT_NOT_FOUND';
export const CONTENT_SCOPE_RESTRICTED = 'CONTENT_SCOPE_RESTRICTED';
export const CUSTOM_WIDGET_NOT_FOUND = 'CUSTOM_WIDGET_NOT_FOUND';
export const CYCLE_DETECTED = 'CYCLE_DETECTED';
export const DISABLED = 'DISABLED';
export const DND_TAG_NOT_IN_DND_AREA = 'DND_TAG_NOT_IN_DND_AREA';
export const DUPLICATE_TEMPLATE_TAG = 'DUPLICATE_TEMPLATE_TAG';
export const EXCEPTION = 'EXCEPTION';
export const EXPORT_TO_TEMPLATE_CONTEXT_TEMPLATE_CANNOT_CONTAIN_SMART_CONTENT = 'EXPORT_TO_TEMPLATE_CONTEXT_TEMPLATE_CANNOT_CONTAIN_SMART_CONTENT';
export const FLEXAREA_MAIN_TAG = 'FLEXAREA_MAIN_TAG';
export const FLEXAREA_ROWS_AND_WIDGETS = 'FLEXAREA_ROWS_AND_WIDGETS';
export const FOLLOW_UP_EMAIL_INVALID = 'FOLLOW_UP_EMAIL_INVALID';
export const FOLLOW_UP_EMAIL_NOT_FOUND = 'FOLLOW_UP_EMAIL_NOT_FOUND';
export const FOLLOW_UP_EMAIL_NOT_PUBLISHED = 'FOLLOW_UP_EMAIL_NOT_PUBLISHED';
export const FOLLOW_UP_EMAIL_NULL = 'FOLLOW_UP_EMAIL_NULL';
export const IMPORT_CYCLE_DETECTED = 'IMPORT_CYCLE_DETECTED';
export const INCLUDE_CYCLE_DETECTED = 'INCLUDE_CYCLE_DETECTED';
export const INVALID_ATTRIBUTE_JSON = 'INVALID_ATTRIBUTE_JSON';
export const INVALID_CHILD_TAG_IN_DND_EMAIL = 'INVALID_CHILD_TAG_IN_DND_EMAIL';
export const INVALID_COLOR_VARIANT_COLOR = 'INVALID_COLOR_VARIANT_COLOR';
export const INVALID_CONVERT_RGB_COLOR = 'INVALID_CONVERT_RGB_COLOR';
export const INVALID_CRM_OBJECT_TYPE = 'INVALID_CRM_OBJECT_TYPE';
export const INVALID_CTA_GUID = 'INVALID_CTA_GUID';
export const INVALID_DICTIONARY_ARGUMENT = 'INVALID_DICTIONARY_ARGUMENT';
export const INVALID_DND_AREA_IN_TEMPLATE = 'INVALID_DND_AREA_IN_TEMPLATE';
export const INVALID_DND_AREA_PROPERTIES = 'INVALID_DND_AREA_PROPERTIES';
export const INVALID_DND_TAG_DESCENDANT = 'INVALID_DND_TAG_DESCENDANT';
export const INVALID_ENUM_ARGUMENT = 'INVALID_ENUM_ARGUMENT';
export const INVALID_INPUT = 'INVALID_INPUT';
export const INVALID_JAVASCRIPT_CALLBACK = 'INVALID_JAVASCRIPT_CALLBACK';
export const INVALID_MODULE_FIELD_VALUE = 'INVALID_MODULE_FIELD_VALUE';
export const INVALID_MODULE_IN_TEMPLATE = 'INVALID_MODULE_IN_TEMPLATE';
export const EMAIL_RENDER_VERSION_CHANGE_WARNING = 'EMAIL_RENDER_VERSION_CHANGE_WARNING';
export const INVALID_NUMBER = 'INVALID_NUMBER';
export const INVALID_OEMBED_CONTEXT = 'INVALID_OEMBED_CONTEXT';
export const INVALID_PERSONALIZATION_TOKEN_EXPRESSION = 'INVALID_PERSONALIZATION_TOKEN_EXPRESSION';
export const INVALID_SECTION_STRUCTURE = 'INVALID_SECTION_STRUCTURE';
export const INVALID_TOTAL_WIDTH = 'INVALID_TOTAL_WIDTH';
export const MACRO_NOT_FOUND = 'MACRO_NOT_FOUND';
export const MENU_UNKNOWN_VALUES = 'MENU_UNKNOWN_VALUES';
export const MINIFICATION_ERROR_jsx = 'MINIFICATION_ERROR_jsx';
export const MISSING = 'MISSING';
export const MISSING_ARGUMENT = 'MISSING_ARGUMENT';
export const MISSING_HUB_DB_TABLE = 'MISSING_HUB_DB_TABLE';
export const MISSING_OBJECT_ID = 'MISSING_OBJECT_ID';
export const MISSING_RESOURCE = 'MISSING_RESOURCE';
export const MISSING_SINGLE_TAG = 'MISSING_SINGLE_TAG';
export const MISSING_TEMPLATE = 'MISSING_TEMPLATE';
export const MISSING_TEMPLATE_TAG = 'MISSING_TEMPLATE_TAG';
export const MODULE_NOT_BLOG_COMPATIBLE = 'MODULE_NOT_BLOG_COMPATIBLE';
export const MODULE_NOT_EMAIL_COMPATIBLE = 'MODULE_NOT_EMAIL_COMPATIBLE';
export const MODULE_NOT_FOUND = 'MODULE_NOT_FOUND';
export const MODULE_NOT_PAGE_COMPATIBLE = 'MODULE_NOT_PAGE_COMPATIBLE';
export const MODULE_PATH_FALLBACK = 'MODULE_PATH_FALLBACK';
export const MULTIPLE_FLEXAREA_TAGS = 'MULTIPLE_FLEXAREA_TAGS';
export const OTHER = 'OTHER';
export const OVER_LIMIT = 'OVER_LIMIT';
export const REFERENCES_TO_COMBINED_CSS = 'REFERENCES_TO_COMBINED_CSS';
export const REFERENCES_TO_RAW_RESOURCE = 'REFERENCES_TO_RAW_RESOURCE';
export const RESOURCE_NOT_FOUND_BY_ID_IN_FUNCTION = 'RESOURCE_NOT_FOUND_BY_ID_IN_FUNCTION';
export const RESOURCE_NOT_FOUND_BY_ID_IN_TAG = 'RESOURCE_NOT_FOUND_BY_ID_IN_TAG';
export const SYNTAX_ERROR = 'SYNTAX_ERROR';
export const SYNTAX_NOT_RECOMMENDED = 'SYNTAX_NOT_RECOMMENDED';
export const TAG_MISSING_NAME = 'TAG_MISSING_NAME';
export const TARGETED_CONTENT_RULE_ERROR = 'TARGETED_CONTENT_RULE_ERROR';
export const TARGETED_CONTENT_RULE_MISSING = 'TARGETED_CONTENT_RULE_MISSING';
export const TEMPLATE_CANNOT_CONTAIN_WIDGET = 'TEMPLATE_CANNOT_CONTAIN_WIDGET';
export const MODULE_RENDERING_WITH_V3_EMAIL = 'MODULE_RENDERING_WITH_V3_EMAIL';
export const EMAIL_RENDER_MODULES_INVALID_VERSION = 'EMAIL_RENDER_MODULES_INVALID_VERSION';
export const TEMPLATE_MISSING_EMAIL_BODY = 'TEMPLATE_MISSING_EMAIL_BODY';
export const TEMPLATE_MISSING_WIDGET = 'TEMPLATE_MISSING_WIDGET';
export const UNKNOWN = 'UNKNOWN';
export const UNKNOWN_DATE = 'UNKNOWN_DATE';
export const UNKNOWN_EMBED_TYPE = 'UNKNOWN_EMBED_TYPE';
export const UNKNOWN_LOCALE = 'UNKNOWN_LOCALE';
export const UNKNOWN_PROPERTY = 'UNKNOWN_PROPERTY';
export const WIDGET_CANNOT_BE_OVERRIDEABLE = 'WIDGET_CANNOT_BE_OVERRIDEABLE';